import { useQuery } from '@tanstack/react-query'

import { getEvidenceInformationForCardTransactions } from '@src/api'
import { DefaultApiGetEvidenceInformationForCardTransactionsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchEvidenceInformationForCardTransactions = (
  params: DefaultApiGetEvidenceInformationForCardTransactionsRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId && !!params.paymentReferenceId,
    queryFn: () =>
      getEvidenceInformationForCardTransactions(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_EVIDENCE_INFORMATION_FOR_CARD_TRANSACTIONS,
      params.organizationId,
      params.paymentReferenceId,
    ],
  })
}
